import DecisionTreeWizard from "./DecisionTreeWizard";

export default DecisionTreeWizard;